module.exports = __webpack_public_path__ + "img/icon-four@3x4.400a7936.png";